export default __webpack_public_path__ + "static/media/stop.5a4ab6bf.png";